// Translations for the Dashboard page (Dashboard.js): member dashboard
// (Swahili-first source text) and staff/admin dashboard (English-first
// source text). t() works the same regardless of which language the
// string is written in.
const dashboardDict = [
  // Member dashboard header
  { en: "Welcome,", sw: "Karibu," },
  { en: "Member", sw: "Mwanachama" },
  { en: "This is your Member page.", sw: "Hii ni ukurasa wako wa Mwanachama." },
  { en: "No member profile found", sw: "Hakuna wasifu wa mwanachama" },
  { en: "Your member profile could not be found. Please contact the head office for help.", sw: "Wasifu wako wa mwanachama haujapatikana. Tafadhali wasiliana na ofisi kuu kwa msaada." },
  { en: "This is your Member page — the essentials at a glance.", sw: "Hii ni ukurasa wako wa Mwanachama — maelezo muhimu haraka." },
  { en: "Unknown", sw: "Haijulikani" },

  // Member stat cards
  { en: "Membership Status", sw: "Hali ya Uanachama" },
  { en: "Inactive", sw: "Haitumiki" },
  { en: "Latest Contribution", sw: "Mchango wa Hivi Karibuni" },
  { en: "Salary:", sw: "Msho:" },
  { en: "Outstanding Loan", sw: "Mkopo Unaobaki" },
  { en: "Next installment:", sw: "Awamu ijayo:" },
  { en: "Upcoming Event", sw: "Tukio Linalokuja" },
  { en: "No upcoming event", sw: "Hakuna tukio" },
  { en: "New Notifications", sw: "Notifications mpya" },
  { en: "Remember to check messages and meetings", sw: "Kumbuka kuangalia ujumbe na mikutano" },

  // Member module grid
  { en: "Module by Module — What a Member Sees", sw: "Module kwa Module — Mwanachama Ataona Nini" },
  { en: "Member Management", sw: "Usimamizi wa Wanachama" },
  { en: "View & edit profile, download ID (QR)", sw: "Angalia na hariri wasifu, pakua kitambulisho (QR)" },
  { en: "Contributions", sw: "Michango" },
  { en: "View history, pay manually if payroll missed", sw: "Angalia historia, lipa mwenyewe kama malipo ya mshahara hayakukatwa" },
  { en: "Loans", sw: "Mikopo" },
  { en: "View loans, repayment schedule & status", sw: "Angalia mikopo, ratiba ya malipo na hali" },
  { en: "Communications", sw: "Mawasiliano" },
  { en: "Announcements, SMS history & meeting notices", sw: "Matangazo, historia ya SMS na taarifa za mikutano" },
  { en: "Meetings", sw: "Mikutano" },
  { en: "Agenda, minutes, vote (if open)", sw: "Ajenda, kumbukumbu, piga kura (kama zipo wazi)" },
  { en: "Trainings", sw: "Mafunzo" },
  { en: "Upcoming trainings, register & download certificates", sw: "Mafunzo yanayokuja, jisajili na pakua vyeti" },
  { en: "Elections", sw: "Uchaguzi" },
  { en: "View candidates, vote when election is open", sw: "Angalia wagombea, piga kura wakati uchaguzi umefunguliwa" },
  { en: "Digital ID", sw: "ID ya Kidigitali" },
  { en: "View QR code, membership number & payment history", sw: "Angalia msimbo wa QR, namba ya uanachama na historia ya malipo" },
  { en: "Disputes", sw: "Migogoro" },
  { en: "Report a case, upload docs and track status", sw: "Ripoti mgogoro, pakia nyaraka na fuatilia hali" },
  { en: "Education & Library", sw: "Elimu & Library" },
  { en: "Read policies, download PDFs", sw: "Soma sera, pakua PDF" },
  { en: "Helpdesk", sw: "Msaada" },
  { en: "Submit a ticket & track progress", sw: "Wasilisha tiketi na fuatilia maendeleo" },
  { en: "Calendar", sw: "Kalenda" },
  { en: "Events, trainings, elections & meetings", sw: "Matukio, mafunzo, uchaguzi na mikutano" },

  // Member detail cards
  { en: "Contributions (History)", sw: "Michango (History)" },
  { en: "View all", sw: "Angalia zote" },
  { en: "Paid", sw: "Kilicholipwa" },
  { en: "No contributions yet.", sw: "Bado hakuna michango." },
  { en: "Loan", sw: "Mkopo" },
  { en: "Active", sw: "Inatumika" },
  { en: "No loans found.", sw: "Hakuna mikopo iliyopatikana." },
  { en: "Notifications", sw: "Arifa" },
  { en: "No notifications", sw: "Hakuna arifa" },

  // Staff/admin dashboard
  { en: "Welcome back,", sw: "Karibu tena," },
  { en: "User", sw: "Mtumiaji" },
  { en: "Here's what's happening with your union today.", sw: "Haya ndiyo yanayoendelea na chama chako leo." },
  { en: "Total Members", sw: "Jumla ya Wanachama" },
  { en: "Suspended", sw: "Amesimamishwa" },
  { en: "Active Loans", sw: "Mikopo Inayoendelea" },
  { en: "Total", sw: "Jumla" },
  { en: "Total Disbursed", sw: "Jumla Iliyotolewa" },
  { en: "Outstanding", sw: "Kiasi kinachodaiwa" },
  { en: "3 New", sw: "3 Mpya" },
  { en: "Pending Applications", sw: "Maombi Yanayosubiri" },
  { en: "Review Now →", sw: "Kagua Sasa →" },
  { en: "Quick Actions", sw: "Vitendo vya Haraka" },
  { en: "Add New Member", sw: "Ongeza Mwanachama Mpya" },
  { en: "Register a new member to the union", sw: "Sajili mwanachama mpya kwenye chama" },
  { en: "Record Contribution", sw: "Rekodi Mchango" },
  { en: "Add new member contribution", sw: "Ongeza mchango wa mwanachama" },
  { en: "Loan Application", sw: "Maombi ya Mkopo" },
  { en: "Process new loan request", sw: "Chakata ombi jipya la mkopo" },
  { en: "Send Announcement", sw: "Tuma Tangazo" },
  { en: "Broadcast message to members", sw: "Sambaza ujumbe kwa wanachama" },
  { en: "Monthly Contributions", sw: "Michango ya Kila Mwezi" },
  { en: "No contribution data available", sw: "Hakuna taarifa za michango zilizopo" },
  { en: "Start recording contributions to see analytics", sw: "Anza kurekodi michango ili kuona uchambuzi" },
  { en: "Recent Announcements", sw: "Matangazo ya Hivi Karibuni" },
  { en: "View All →", sw: "Angalia Yote →" },
  { en: "General", sw: "Jumla" },
  { en: "No preview available", sw: "Hakuna muhtasari" },
  { en: "No announcements yet", sw: "Bado hakuna matangazo" },
  { en: "Create your first announcement", sw: "Unda tangazo lako la kwanza" },
  { en: "Retired Members", sw: "Wanachama Waliostaafu" },
  { en: "Active This Month", sw: "Wanaoendelea Mwezi Huu" },
  { en: "Outstanding Loans", sw: "Mikopo Iliyobaki" },
  { en: "Active Loan Accounts", sw: "Akaunti za Mikopo Zinazoendelea" },
];

export default dashboardDict;
